import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/models/'
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/org/$orgId/workspace/$workspaceId/roster',
      params,
      replace: true,
    })
  },
})
